import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { createFormFieldId } from "../helpers/createFormFieldId.js";
import { getFormFieldState } from "../helpers/getFormFieldState.js";
import FormElementContainer from "../shared/FormElementContainer/FormElementContainer.js";
import FormFieldDecoration from "../shared/FormFieldDecoration/index.js";
import InputElement from "./components/InputElement.js";
import { MAX_LENGTH } from "./constants.js";
const InputField = /*#__PURE__*/ forwardRef(({ id, label, hidden, maxLength = MAX_LENGTH, size = 'sm', error = false, full = false, helperText, hideLabel, subLabelElement, info, tooltip, leadingIcon, trailingIcon, leadingElement, trailingElement, containerClassName, ...inputProps }, ref)=>{
    const inputId = createFormFieldId({
        id,
        label,
        trailing: 'input'
    });
    const fieldState = getFormFieldState({
        disabled: inputProps.disabled,
        error
    });
    const { draggable, onDrag, onDragStart, onDragEnd } = inputProps;
    const formElementProps = {
        size,
        fieldState,
        leadingIcon,
        leadingElement,
        trailingIcon,
        trailingElement,
        draggable,
        onDrag,
        onDragStart,
        onDragEnd
    };
    return /*#__PURE__*/ jsx(FormFieldDecoration, {
        full: full,
        hidden: hidden,
        childrenId: inputId,
        label: label,
        state: fieldState,
        helperText: helperText,
        hideLabel: hideLabel,
        subLabelElement: subLabelElement,
        info: info,
        size: size,
        tooltip: tooltip,
        containerClassName: containerClassName,
        children: /*#__PURE__*/ jsx(FormElementContainer, {
            formElement: /*#__PURE__*/ jsx(InputElement, {
                ref: ref,
                id: inputId,
                label: label,
                size: size,
                inputState: fieldState,
                maxLength: maxLength,
                ...inputProps
            }),
            ...formElementProps
        })
    });
});
InputField.displayName = 'InputField';
const InputField_InputField = InputField;
export default InputField_InputField;
export { InputField };
